import DeleteIcon from "@mui/icons-material/Delete";
import { Button, IconButton, Tooltip, Typography } from "@mui/material";
import { MaterialReactTable, useMaterialReactTable } from "material-react-table";
import { MRT_Localization_ES } from "material-react-table/locales/es";
import { useMemo, useState } from "react";
import { useDispatch } from "react-redux";
import { addLocalGremialista, deleteLocalGremialista } from "../../../../redux/actions/rgrl";
import { tableConfig } from "../../../commons/table/tableConfig";
import { StyledRgrl } from "../../../styled/Prevencion";
import AddGremioDialog from "./dialog/AddGremioDialog";

const GremialistasTable = ({ data, handleSubmit }) => {
  const dispatch = useDispatch();
  const [openAddGremio, setOpenAddGremio] = useState(false);

  const columns = useMemo(() => [
    {
      accessorFn: (row) => row.nombre.split(" - ")[0],
      header: "Nro. de Legajo",
      size: 25,
    },
    {
      accessorFn: (row) => row.nombre.split(" - ")[1],
      header: "Nombre del Gremio",
    },
  ], []);

  const deleteGremio = (values) => {
    dispatch(deleteLocalGremialista(values.id));
  };

  const handleClose = () => {
    setOpenAddGremio(false);
  };

  const addGremio = () => {
    setOpenAddGremio(true);
  };

  const handleSumbitDialog = (values) => {
    dispatch(addLocalGremialista(values));
    setOpenAddGremio(false);
  };

  const table = useMaterialReactTable({
    ...tableConfig,
    columns,
    data: data || [],
    enableRowActions: true,
    positionActionsColumn: "last",
    displayColumnDefOptions: {
    ...tableConfig.displayColumnDefOptions,
    'mrt-row-actions': {
      header: 'Acciones',
      size: 25, // Make column narrower
      muiTableHeadCellProps: {
        align: 'center',
      },
      muiTableBodyCellProps: {
        align: 'center', // Center content in body cells
        sx: { 
          padding: '8px' // Smaller padding
        }
      }
    },
  },
    renderRowActions: ({ row }) => (
      <Tooltip title="Eliminar" placement="bottom">
        <IconButton
          size="small"
          onClick={() => deleteGremio(row.original)}
          color="info"
        >
          <DeleteIcon />
        </IconButton>
      </Tooltip>
    ),
    renderEmptyRowsFallback: () => (
      <StyledRgrl.MessageContainer>
        <Typography>No hay gremialistas agregados</Typography>
      </StyledRgrl.MessageContainer>
    ),
    renderBottomToolbarCustomActions: () => (
      <StyledRgrl.TableButtonContainer>
        <Button
          color="primary"
          onClick={addGremio}
        >
          Agregar
        </Button>
      </StyledRgrl.TableButtonContainer>
    ),
    enablePagination: true,
    paginationDisplayMode: 'pages',
    muiPaginationProps: {
      rowsPerPageOptions: [5, 10, 25],
      labelRowsPerPage: "Filas por página:",
      getItemAriaLabel: (type) => {
        if (type === 'first') return 'ir a la primera página';
        if (type === 'last') return 'ir a la última página';
        if (type === 'next') return 'ir a la página siguiente';
        return 'ir a la página anterior';
      },
      labelDisplayedRows: ({ from, to, count }) =>
        `${from}-${to} de ${count !== -1 ? count : to}`,
    },
    initialState: {
      pagination: {
        pageSize: 5,
        pageIndex: 0,
      },
      density: 'compact',
    },
    enableColumnFilters: false,
    enableGlobalFilter: false,
    enableColumnActions: false,
    enableDensityToggle: false,
    enableFullScreenToggle: false,
    enableHiding: false,
    localization: {
      ...MRT_Localization_ES,
      noRecordsToDisplay: "No hay gremialistas agregados",
    },
  });

  return (
    <>
      <StyledRgrl.TableContainer>
        <MaterialReactTable table={table} />
      </StyledRgrl.TableContainer>
      <AddGremioDialog
        open={openAddGremio}
        handleClose={handleClose}
        handleSumbit={handleSumbitDialog}
      />
    </>
  );
};

export default GremialistasTable;